<template>
  <section class="layout-pt-lg layout-pb-lg" :style="`background-color: var(--c-${vars.backgroundColor})`">
    <div class="container tw-flex tw-w-full tw-flex-col tw-items-center tw-justify-center">
      <div v-html="vars.titleHtml" class="tw-mb-12 lg:tw-mb-14"></div>
      <div class="tw-flex tw-w-full tw-flex-col tw-gap-6 lg:tw-flex-row lg:tw-gap-10 xl:tw-gap-12">
        <div
          v-for="card in cards"
          class="tw-flex tw-flex-1 tw-flex-col tw-gap-6 tw-border tw-p-7"
          style="border-color: var(--c-border)"
        >
          <div class="tw-h-28 tw-w-28">
            <library-image :src="card.icon" :alt="card.title" image-class="tw-h-full tw-w-full" />
          </div>
          <h5>{{ card.title }}</h5>
          <p>{{ card.description }}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { ComponentMixin } from '~/mixins/component.mixin';

export default defineNuxtComponent({
  name: 'Theme7OurValues',

  mixins: [ComponentMixin],

  data() {
    return {};
  },

  computed: {
    cards() {
      return this.groupedVariables.cards;
    },
  },
});
</script>
